<template>
    <div>
        <div v-if="page == 0">
            <nav aria-label="items-project">
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a
                        class="nav-item nav-link active"
                        id="nav-internal-tab"
                        data-toggle="tab"
                        href="#nav-internal"
                        role="tab"
                        aria-controls="nav-internal"
                        aria-selected="true"
                        >Internos</a
                    >
                    <a
                        class="nav-item nav-link"
                        id="nav-external-tab"
                        data-toggle="tab"
                        href="#nav-external"
                        role="tab"
                        aria-controls="nav-external"
                        aria-selected="false"
                        >Externos</a
                    >
                    <a
                        class="nav-item nav-link"
                        id="nav-optional-tab"
                        data-toggle="tab"
                        href="#nav-optional"
                        role="tab"
                        aria-controls="nav-optional"
                        aria-selected="false"
                        >Opcionales</a
                    >
                </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
                <div
                    class="tab-pane fade show active"
                    id="nav-internal"
                    role="tabpanel"
                    aria-labelledby="nav-internal-tab"
                >
                    <div class="py-2">
                        <button
                            type="button"
                            class="btn btn-outline-primary"
                            @click="getFileWithRating(1)"
                        >
                            Descargar Calificaciones Fase 1
                        </button>
                    </div>
                    <div v-if="!existInternal">
                        <p class="text-center mt-2">
                            Aún no hay ningún jurado interno inscrito. Inscriba
                            un jurado y asígnele las categorías a calificar
                        </p>
                    </div>
                    <table class="table" v-else>
                        <thead>
                            <tr>
                                <th scope="col">Opciones</th>
                                <th scope="col">ID</th>
                                <th scope="col">Nombre</th>
                                <th scope="col">Email</th>
                                <th scope="col">Categorias</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="sworn in internal" v-bind:key="sworn.id">
                                <td>
                                    <div class="flex-btn">
                                        <button
                                            type="button"
                                            v-tooltip.bottom-start="'Editar'"
                                            @click="
                                                changeViewWithParams(3, sworn)
                                            "
                                            class="btn btn-warning btn-sm"
                                        >
                                            <em class="fa fa-pencil"></em>
                                        </button>
                                    </div>
                                </td>
                                <td>{{ sworn.user.id }}</td>
                                <td>{{ sworn.user.name }}</td>
                                <td>{{ sworn.user.email }}</td>
                                <td>
                                    <span
                                        v-for="(
                                            category, idx
                                        ) in getBadgesActiveCategories(
                                            sworn.user,
                                            'internal'
                                        )"
                                        v-bind:key="idx"
                                        class="badge badge-success mr-2"
                                        >{{ category }}</span
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div
                    class="tab-pane fade show"
                    id="nav-external"
                    role="tabpanel"
                    aria-labelledby="nav-external-tab"
                >
                    <div class="py-2">
                        <button
                            type="button"
                            class="btn btn-outline-primary"
                            @click="getFileWithRating(2)"
                        >
                            Descargar Calificaciones Fase 2
                        </button>
                        <button
                            type="button"
                            class="btn btn-outline-primary"
                            @click="getFileWithRating(3)"
                        >
                            Descargar Calificaciones Fase 3
                        </button>
                    </div>
                    <div v-if="!existExternal">
                        <p class="text-center mt-2">
                            Aún no hay ningún jurado externo inscrito. Inscriba
                            un jurado y asígnele las categorías a calificar
                        </p>
                    </div>
                    <table class="table" v-else>
                        <thead>
                            <tr>
                                <th scope="col">Opciones</th>
                                <th scope="col">ID</th>
                                <th scope="col">Nombre</th>
                                <th scope="col">Email</th>
                                <th scope="col">Categorias</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="sworn in external" v-bind:key="sworn.id">
                                <td>
                                    <div class="flex-btn">
                                        <button
                                            type="button"
                                            v-tooltip.bottom-start="'Editar'"
                                            @click="
                                                changeViewWithParams(3, sworn)
                                            "
                                            class="btn btn-warning btn-sm"
                                        >
                                            <em class="fa fa-pencil"></em>
                                        </button>
                                    </div>
                                </td>
                                <td>{{ sworn.user.id }}</td>
                                <td>{{ sworn.user.name }}</td>
                                <td>{{ sworn.user.email }}</td>
                                <td>
                                    <span
                                        v-for="(
                                            category, idx
                                        ) in getBadgesActiveCategories(
                                            sworn.user,
                                            'external'
                                        )"
                                        v-bind:key="idx"
                                        class="badge badge-success mr-2"
                                        >{{ category }}</span
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div
                    class="tab-pane fade show"
                    id="nav-optional"
                    role="tabpanel"
                    aria-labelledby="nav-optional-tab"
                >
                    <div v-if="!existOptional">
                        <p class="text-center mt-2">
                            Aún no hay ningún jurado opcional inscrito. Inscriba
                            un jurado y asígnele las categorías a calificar
                        </p>
                    </div>
                    <table class="table" v-else>
                        <thead>
                            <tr>
                                <th scope="col">Opciones</th>
                                <th scope="col">ID</th>
                                <th scope="col">Nombre</th>
                                <th scope="col">Email</th>
                                <th scope="col">Categorias</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="sworn in optional" v-bind:key="sworn.id">
                                <td>
                                    <div class="flex-btn">
                                        <button
                                            type="button"
                                            v-tooltip.bottom-start="'Editar'"
                                            @click="
                                                changeViewWithParams(3, sworn)
                                            "
                                            class="btn btn-warning btn-sm"
                                        >
                                            <em class="fa fa-pencil"></em>
                                        </button>
                                    </div>
                                </td>
                                <td>{{ sworn.user.id }}</td>
                                <td>{{ sworn.user.name }}</td>
                                <td>{{ sworn.user.email }}</td>
                                <td>
                                    <span
                                        v-for="(
                                            category, idx
                                        ) in getBadgesActiveCategories(
                                            sworn.user,
                                            'optional'
                                        )"
                                        v-bind:key="idx"
                                        class="badge badge-success mr-2"
                                        >{{ category }}</span
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import helpers from "../../mixins/index";
export default {
    props: {
        contestId: Number,
    },
    mixins: [helpers],
    data() {
        return {
            internal: [],
            external: [],
            optional: [],
            page: 0,
        };
    },

    computed: {
        existInternal() {
            return this.internal.length > 0;
        },
        existExternal() {
            return this.external.length > 0;
        },
        existOptional() {
            return this.optional.length > 0;
        },
    },

    methods: {
        changeView(page) {
            this.$emit("change", page);
        },

        changeViewWithParams(page, params) {
            const data = {
                contestId: this.contestId,
                swornId: params.user_id,
                swornType: params.type,
                page: page,
            };

            this.$emit("change", data);
        },

        getModel() {
            let me = this;
            axios
                .get(`/api/sworn_/${me.contestId}`)
                .then(function (response) {
                    const { data } = response.data;
                    me.internal = data.sworn.internal ?? [];
                    me.external = data.sworn.external ?? [];
                    me.optional = data.sworn.optional ?? [];
                })
                .catch(function (error) {});
        },
        getActiveCategories(sworn, type) {
            return sworn.categories_sworn.filter((category) => {
                return (
                    category.type == type &&
                    (category.evolution == 1 || category.increase == 1)
                );
            });
        },
        getBadgesActiveCategories(sworn, type) {
            const categories = this.getActiveCategories(sworn, type);

            return categories.map((item) => {
                return item.category.name;
            });
        },
        async getFileWithRating(phase) {
            const me = this;
            const slug = me.$store.getters.getContest?.slug;

            me.loading();
            axios
                .get(`/api/excel-admin-all/${slug}/${phase}`)
                .then(function (response) {
                    if (response && response?.config?.url) {
                        window.open(
                            response.config.url,
                            "_blank",
                            "noopener, noreferrer"
                        );
                    }
                })
                .catch(function (error) {
                    me.showAlert(
                        "error",
                        "Ha ocurrido un error",
                        error?.response?.data?.message ??
                            error?.response?.data?.messages
                    );
                })
                .finally(() => {
                    me.closeLoading();
                });
        },
    },
    mounted() {
        let me = this;
        me.getModel();
    },
};
</script>
<style scoped>
.flex-btn {
    display: flex;
    gap: 0.3em;
}
</style>
